import React from 'react'
import Main from '../Components/RegisterComponent/Main'

const Register = () => {
  return (
    <>
      <Main />
    </>
  )
}

export default Register
